import React, { useState, useEffect } from "react";
import "@styles/pages/MemberZone/MemberZone.scss";
import { Box, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import Profile from "@pages/MemberZone/Profile";
import MyProducts from "@pages/MemberZone/MyProducts";
import MyRedemptions from "@pages/MemberZone/MyRedemptions";
import PointsHistory from "@pages/MemberZone/PointsHistory";
import MemberInquiry from "@pages/MemberZone/MemberInquiry/MemberInquiry";

import {
  getPointHistory,
  getRegisteredProduct,
  getRedeemHistory,
} from "@api/memberApi";
import { getEnrollmentList } from "@api/enrollmentApi";

import { useDispatch } from "react-redux";
// import { setMemberInfoData } from "@store/member/memberInfoSlice";
import { setPointHistory } from "@store/member/memberPointSlice";
import { setMyProductList } from "@store/member/memberMyProductSlice";
import { setMyRedemptionList } from "@store/member/memberMyRedemptionSlice";
import {
  setInquiryHistoryData,
  updateInquiryLoginData,
} from "@store/inquiry/inquirySlice";
import { useLocation } from "react-router-dom";
import { setFormStep } from "@store/ui/formStepSlice";

const MemberZone = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [currentStep, setCurrentStep] = useState(0);

  const menuItems = [
    "member:profile",
    "member:my_products",
    "member:my_redemptions",
    "member:point_history",
    "member:event_inquiry",
  ];

  const getPointHistoryData = async () => {
    try {
      const res = await getPointHistory();
      console.log(res.data.Data);
      dispatch(setPointHistory(res.data.Data));
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  const getRegisteredProductData = async () => {
    try {
      const res = await getRegisteredProduct();
      dispatch(setMyProductList(res.data.Data));
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  const getRedeemHistoryData = async () => {
    try {
      const res = await getRedeemHistory();
      console.log(res);
      dispatch(setMyRedemptionList(res.data.Data));
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  const fetchEnrollmentList = async (d) => {
    try {
      const res = await getEnrollmentList(d);
      const data = res.data.Data;

      if (data.length === 0) {
        dispatch(setFormStep({ formKey: "memberInquiry", step: 0 }));
        return;
      }

      dispatch(setInquiryHistoryData(data));
      dispatch(setFormStep({ formKey: "memberInquiry", step: 1 }));
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  useEffect(() => {
    getPointHistoryData();
    getRegisteredProductData();
    getRedeemHistoryData();
    fetchEnrollmentList("");
  }, []);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const section = query.get("section");

    if (section === "member_inquiry") {
      setCurrentStep(4);
    }
  }, [location.search]);
  return (
    <Box className="member-zone-container">
      <Typography className="title">
        <Trans  i18nKey="member:member_zone"/>
      </Typography>
      {/* <img
        className="member-image"
        src={`${process.env.PUBLIC_URL}/assets/images/member/MemberZone.png`}
        alt="MemberZone"
      /> */}
      <Box className="member-step-container">
        <Box className="member-nav-container">
          <Box className="member-navbar">
            {menuItems.map((key, index) => (
              <Typography
                key={key}
                className={`member-navbar-item ${
                  currentStep === index ? "selected" : ""
                }`}
                onClick={() => setCurrentStep(index)}
              >
                <Trans i18nKey={key} />
              </Typography>
            ))}
          </Box>
        </Box>
        <Box className="member-detail-container">
          {currentStep === 0 && <Profile />}
          {currentStep === 1 && <MyProducts />}
          {currentStep === 2 && <MyRedemptions />}
          {currentStep === 3 && <PointsHistory />}
          {currentStep === 4 && <MemberInquiry />}
        </Box>
      </Box>
    </Box>
  );
};

export default MemberZone;
